<template>
    <div class="content-wrapper" style="background-image: url('https://sisac.acreditacion.gob.ec/storage/Fplat.jpg')">
        <div class="row">
            <div class="col-12">
                <h4 style="color:#021444">Por OEC Acreditado</h4>
                <p>A continuación, encontrará diferentes filtros para realizar su consulta. Digite el nombre o parte del nombre, para realizar la búsqueda, el sistema filtrará por defecto todos
                    los
                    organismos que se encuentran acreditados y coincidan con la palabra digitada.</p>
            </div>
            <div class="col-12 alert alert-primary" style="background-image: url('https://sisac.acreditacion.gob.ec/storage/Fplat.jpg'); border-color: #021444">
                <div class="row">
                    <div class="col-8">
                        <label for="inputs_accreditation_area_id">
                            {{ $t("Digite el nombre o parte del nombre del OEC o el RUC") }}
                        </label>
                        <app-input id="inputs_accreditation_area_id" type="text" v-model="name" :required="true" style="background-color: #021444; border-color: #021444;" @keyup.enter="onChangeAccreditationActivity" />
                    </div>

                    <!-- <div class="col-6">
                        <label for="inputs_accreditation_activity_id">
                            {{ $t("activity") }}
                        </label>
                        <app-input id="inputs_accreditation_activity_id" type="select" v-model="activity_id"
                            :list="accreditationActivityLists" :required="true" />
                    </div> -->
                    <div class="col-4" style="padding-top:10px">
                        <br />
                        <button type="button" style="margin_top:10px !important;background-color: #021444; border-color: #021444;" class="btn btn-warning btn-lg btn-block" @click.prevent="onChangeAccreditationActivity">
                            <app-icon name="search"  />
                            Buscar
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <app-table :id="tableId" :options="options" @action="getListAction" />
            </div>
        </div>
        <scopes-modal-view v-if="historicalModalActive" :scope-id="rowData.accreditation_application.id"
            :activity="rowData.accreditation_application.accreditation_activity.code"
            @close-modal="historicalModalClose" />
    </div>
</template>
<script>
    import CoreLibrary from "@/core/helpers/CoreLibrary.js";
    import { FormMixin } from '../../../../../core/mixins/form/FormMixin';
    import { axiosGet } from '../../../../helpers/AxiosHelper';
    import { TableHelpers } from "./TableHelpers";
    export default {
        extends: CoreLibrary,
        mixins: [FormMixin, TableHelpers],
        data() {
            return {
                tableId: "index-scopes-table",
                selectedUrl: "",
                rowData: {},
                area_id: "",
                name: "",
                id_search: "",
                options: {
                    url: `/accreditations/get-oec/by_name/${this.name}`,
                    name: "",
                    showHeader: true,
                    columns: [],
                    actions: [
                        {
                            title: this.$t("Alcance"),
                            icon: "align-center",
                            type: "none",
                            component: "FormRequestModal",
                            modalId: "modal-add-edit",
                        },
                        {
                            title: this.$t("Ver PDF"),
                            icon: "file-text",
                            type: "none",
                            component: "app-confirmation-modal",
                            modalId: "modal-delete",
                        },
                    ],
                    showFilter: false,
                    showSearch: false,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: "desc",
                    actionType: "default",
                },
                isAddEditModalActive: false,
                inputs: [],
                accreditationAreaList: [],
                accreditationActivityList: [],
                accreditationActivityLists: [],
    
                historicalModalActive: false,
                scopeId: null,
            }
        },
        // watch: {
    
        //     "id_search": function () {
        //         this.tableId = "index-scopes-table",
        //         this.options = {
        //             url: `/accreditations/get-oec/${this.activity_id}`,
        //             name: "",
        //             showHeader: true,
        //             columns: [],
        //             actions: [
        //                 {
        //                     title: this.$t("edit"),
        //                     icon: "align-center",
        //                     type: "none",
        //                     component: "FormRequestModal",
        //                     modalId: "modal-add-edit",
        //                 },
        //                 /* {
        //                     title: this.$t("delete"),
        //                     icon: "trash",
        //                     type: "none",
        //                     component: "app-confirmation-modal",
        //                     modalId: "modal-delete",
        //                 }, */
        //             ],
        //             showFilter: false,
        //             showSearch: false,
        //             paginationType: "pagination",
        //             responsive: true,
        //             rowLimit: 10,
        //             showAction: true,
        //             orderBy: "desc",
        //             actionType: "default",
        //         };
        //         this.options.columns = [
        //             ...this.tableColumns,
        //             this.disabled ? [] : this.actionObj,
        //         ];
        //         this.$hub.$emit("reload-" + this.tableId);
        //     }
        // },
    
        created() {
            this.dataInitial();
            this.options.columns = [
                ...this.tableColumns,
                this.disabled ? [] : this.actionObj,
            ];
        },
    
        methods: {
    
            onChangeAccreditationArea() {
                this.accreditationActivityLists = [
                    { id: "", value: "Selecciona una opción" },
                    ...this.accreditationActivityList.filter((item) => {
                        return item.parent == this.area_id;
                    }),
                ];
            },
    
            historicalModalClose() {
                this.historicalModalActive = false;
            },
    
            onChangeAccreditationActivity() {
                console.log(this.name)
                this.id_search = this.activity_id;
    
                this.options = {
                    url: `/accreditations/get-oec/by_name/${this.name}`,
                    name: "",
                    showHeader: true,
                    columns: [],
                    actions: [
                        {
                            title: this.$t("Alcance"),
                            icon: "align-center",
                            type: "none",
                            component: "FormRequestModal",
                            modalId: "modal-add-edit",
                        },
                        {
                            title: this.$t("Ver PDF"),
                            icon: "file-text",
                            type: "none",
                            component: "app-confirmation-modal",
                            modalId: "modal-delete",
                        },
                    ],
                    showFilter: true,
                    showSearch: true,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: "desc",
                    actionType: "default",
                };
                this.options.columns = [
                    ...this.tableColumns,
                    this.disabled ? [] : this.actionObj,
                ];
    
                setTimeout(() => this.$hub.$emit("reload-" + this.tableId), 500);
    
    
            },
    
            getListAction(rowData, actionObj, active) {
                this.rowData = rowData;
                if (actionObj.title == this.$t("Ver PDF")) {
                    const url = `/common/scopes/exportActiveScopes?
                    type='pdf'
                    &accAppId=${rowData.accreditation_application.id}
                    &statusId=${null}
                    &tableName=active`;
                    window.open(url, "_blank").focus();
                } else if (actionObj.title == this.$t("Alcance")) {
                    /* const result = this.axiosGet(
                        `request/scopes_historical?accAppId=${rowData.acc_app_id}&statusId=`
                    );
                    console.log(rowData);
                    const historical = result.data.data;
                    const original = historical.filter((row) => row.status_id == null); */
                    console.log(rowData.accreditation_application.accreditation_activity)
                    this.historicalModalActive = true;
                }
            },
    
            dataInitial() {
                // this.preloader = true;
                let uri = `/options`;
                axiosGet(uri).then((response) => {
                    this.accreditationAreaList = [
                        { id: "", value: "Selecciona una opción" },
                        ...response.data.accreditationAreas,
                    ];
    
                    this.accreditationActivityList = [
                        { id: "", value: "Selecciona una opción" },
                        ...response.data.accreditationActivities,
                    ];
                })
            },
    
            getFilter() {
                this.options = {
                    url: `/accreditations/get-oec/by_name/${this.activity_id}`,
                    name: "",
                    showHeader: true,
                    columns: [],
                    actions: [
                        {
                            title: this.$t("Alcance"),
                            icon: "align-center",
                            type: "none",
                            component: "FormRequestModal",
                            modalId: "modal-add-edit",
                        },
                        /* {
                            title: this.$t("delete"),
                            icon: "trash",
                            type: "none",
                            component: "app-confirmation-modal",
                            modalId: "modal-delete",
                        }, */
                    ],
                    showFilter: false,
                    showSearch: false,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: "desc",
                    actionType: "default",
                }
            }
    
        },
    }
    </script>